// Bank statement ingestion status: chip labels and URL params.

/** Figma's 4 chips plus `Unsupported File` (a format failure) — no `Enter Password` / `Truncated File` chip. */
export const INGESTION_CHIP = {
    PENDING: 'Pending',
    IN_PROGRESS: 'In Progress',
    DATA_EXTRACTED: 'Data Extracted',
    PARTIALLY_EXTRACTED: 'Partially Extracted',
    FAILED: 'Failed',
    UNSUPPORTED_FILE: 'Unsupported File',
} as const;
export type IngestionChip = (typeof INGESTION_CHIP)[keyof typeof INGESTION_CHIP];

/** Hover copy for the trailing chip ⓘ. `Failed` and `Unsupported File` use the doc's own `ingestionReason` instead. */
export const CHIP_TOOLTIP_TEXT = {
    [INGESTION_CHIP.PENDING]: 'Data extraction is pending for this file',
    [INGESTION_CHIP.IN_PROGRESS]: 'Data extraction is in progress for this file',
    [INGESTION_CHIP.DATA_EXTRACTED]: 'Data has been extracted for this file',
} as const;

/** Recovery action UE attaches to a failed or partial provisional doc. */
export const INGESTION_ACTION = { REUPLOAD: 'REUPLOAD' } as const;
export type IngestionAction = (typeof INGESTION_ACTION)[keyof typeof INGESTION_ACTION];

/** `fileMetaData.ingestionSource` of a provisional-financials doc (bank docs carry none). */
export const INGESTION_SOURCE = { PROVISIONAL_FINANCIALS: 'PROVISIONAL_FINANCIALS' } as const;
export type IngestionSource = (typeof INGESTION_SOURCE)[keyof typeof INGESTION_SOURCE];

export const REUPLOAD_MENU_LABEL = 'Upload again';

/** Most reasons shown for a not-ingested provisional file; the engine caps at the same number. */
export const MAX_STATUS_REASONS = 2;

/** Data Room URL params: doc-type filter (comma-joined directoryMap ids) and Review Now expansion. */
export const DATA_ROOM_URL_PARAMS = {
    DOC_TYPES: 'docTypes',
    /** "1" ⇒ account folders with a Failed file start open. */
    EXPAND_FAILED: 'expandFailed',
} as const;

/** directoryMap id of the Bank Statements folder, used by the filter and the Review Now link. */
export const BANK_STATEMENTS_DOC_TYPE_ID = 'Bank Statements';

/** directoryMap id of the Provisional Financials folder, used by the filter and the Review Now link. */
export const PROVISIONAL_FINANCIALS_DOC_TYPE_ID = 'MIS & Provisional Financials';
